/*eslint-disable*/
import Flickity from 'flickity'
import vsbl from 'vsbl'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default featured => {
  const slideshow = featured.querySelector('.js-featured-slideshow')
  const leftControl = featured.querySelector('.js-carousel-left')
  const rightControl = featured.querySelector('.js-carousel-right')

  const collectionHeader = featured.querySelector('.js-collection-header')
  vsbl(collectionHeader, { threshold: 0.25 })(() => {
    collectionHeader.classList.add('is-visible')
  })
  vsbl(slideshow, { threshold: 0.25 })(() => {
    slideshow.classList.add('is-visible')
  })
  vsbl(slideshow, { threshold: 2 })(() => {
    let height = $(slideshow).find('.flickity-viewport .js-product-card').height()
    $(slideshow).find('.flickity-viewport').css({ 'height': `${height + 40}px` })
  })
  vsbl(leftControl, { threshold: 0.25 })(() => {
    leftControl.classList.add('is-visible')
  })
  vsbl(rightControl, { threshold: 0.25 })(() => {
    rightControl.classList.add('is-visible')
  })
  if (slideshow) {
    const flktyParams = {
      contain: true,
      lazyLoad: 2,
      pageDots: false,
      prevNextButtons: false,
      freeScroll: false
    }
    window.matchMedia("(min-width:768px)").matches 
    ? flktyParams.groupCells = 2
    : flktyParams.groupCells = false
    const flkty = new Flickity(slideshow, flktyParams)
    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
    $(window).bind('scroll.featuredProducts', () => { //To resize the related products flickity module when scrolling down the page - this ensures it doesn't get stuck and not fully expand
      if($(window).scrollTop() + 1500 >= $(featured).offset().top){
        flkty.resize()
        $(window).off('scroll.featuredProducts')
      } 
    })
    setTimeout(() => {
      flkty.resize()
    }, 1500)
    leftControl.addEventListener('click', () => {
      flkty.previous()
    })
    rightControl.addEventListener('click', () => {
      flkty.next()
    })
  } 
}



// WEBPACK FOOTER //
// ./src/scripts/components/featured-carousel.js